
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { MicrosoftTenantModel } from 'models/generated/Distribution.Api.Models.MicrosoftTenant';
import { CustomerTenantModel } from 'models/generated/Distribution.Api.Models.Csp.CustomerTenant';


const _distribution_TenantControllerHelper = new Map<string, Object>();
_distribution_TenantControllerHelper.set('GetMicrosoftTenants', MicrosoftTenantModel);
_distribution_TenantControllerHelper.set('GetCrayonTenants', CustomerTenantModel);
_distribution_TenantControllerHelper.set('GetCrayonTenantById', CustomerTenantModel);
_distribution_TenantControllerHelper.set('CreateCrayonTenant', CustomerTenantModel);
_distribution_TenantControllerHelper.set('UpdateCrayonTenant', CustomerTenantModel);
_distribution_TenantControllerHelper.set('GetMicrosoftTenantByCompanyId', MicrosoftTenantModel);
_distribution_TenantControllerHelper.set('GetMicrosoftTenantsByCompanyIds', MicrosoftTenantModel);
_distribution_TenantControllerHelper.set('SearchCustomerTenantsAsync', CustomerTenantModel);


export const distribution_TenantControllerHelper = _distribution_TenantControllerHelper;

